export { default } from './CopyText';
